import { render, staticRenderFns } from "./VBtn.vue?vue&type=template&id=7b083d98"
import script from "./VBtn.vue?vue&type=script&lang=js"
export * from "./VBtn.vue?vue&type=script&lang=js"
import style0 from "./VBtn.vue?vue&type=style&index=0&id=7b083d98&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b083d98')) {
      api.createRecord('7b083d98', component.options)
    } else {
      api.reload('7b083d98', component.options)
    }
    module.hot.accept("./VBtn.vue?vue&type=template&id=7b083d98", function () {
      api.rerender('7b083d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VBtn.vue"
export default component.exports